import { createContext } from "react";

const doctorsInfoContext= createContext();

export default doctorsInfoContext;